import React, { useState } from "react"
import { useParams, useNavigate, Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
// Data
import { updateShop } from "../../redux/apiCalls"
// Styles
import {
   Container,
   Wrapper,
   Main,
   StyledButton,
   Title,
   TitleWrapper,
   WideBox,
   BoxTitle,
   FormItem,
   StyledForm,
   StyledLabel,
   StyledInput,
   ButtonContainer,
   ButtonWrapper,
   Message,
   UserWrapper,
} from "./Shop.styles"

const Shop = () => {
   const { shopId } = useParams()
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const [errorMessage, setErrorMessage] = useState("")

   const shop = useSelector((state) =>
      state.shop.shops.find((shop) => shop?._id === shopId)
   )
   const [shopInputs, setShopInputs] = useState({})

   const handleChange = (e) => {
      setShopInputs((prev) => {
         return { ...prev, [e.target.name]: e.target.value }
      })
   }

   const handleSubmit = async (e) => {
      e.preventDefault()
      const res = await updateShop(shopId, shopInputs, dispatch)
      if (res === "success") {
         navigate("/shops")
      } else {
         setErrorMessage(JSON.stringify(res))
      }
   }

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>Edit Shop</Title>
                  <Link to="/newShop">
                     <StyledButton>Create</StyledButton>
                  </Link>
               </TitleWrapper>
               <UserWrapper>
                  <WideBox>
                     <BoxTitle>Edit</BoxTitle>

                     <StyledForm>
                        <FormItem>
                           <StyledLabel>Customer Code</StyledLabel>
                           <StyledInput
                              type="text"
                              name="customerCode"
                              defaultValue={shop?.customerCode}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Name</StyledLabel>
                           <StyledInput
                              type="text"
                              name="name"
                              defaultValue={shop?.name}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Address</StyledLabel>
                           <StyledInput
                              type="text"
                              name="address"
                              defaultValue={shop?.address}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Zip code</StyledLabel>
                           <StyledInput
                              type="text"
                              name="zip"
                              defaultValue={shop?.zip}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>City</StyledLabel>
                           <StyledInput
                              type="text"
                              name="city"
                              defaultValue={shop?.city}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Email</StyledLabel>
                           <StyledInput
                              type="text"
                              name="mail"
                              defaultValue={shop?.mail}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Phone</StyledLabel>
                           <StyledInput
                              type="text"
                              name="phone"
                              defaultValue={shop?.phone}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Latitude</StyledLabel>
                           <StyledInput
                              type="number"
                              name="lat"
                              defaultValue={shop?.lat}
                              onChange={handleChange}
                           />
                        </FormItem>
                        <FormItem>
                           <StyledLabel>Longitude</StyledLabel>
                           <StyledInput
                              type="number"
                              name="lng"
                              defaultValue={shop?.lng}
                              onChange={handleChange}
                           />
                        </FormItem>
                     </StyledForm>
                  </WideBox>
               </UserWrapper>
               <ButtonContainer>
                  <ButtonWrapper>
                     <StyledButton onClick={handleSubmit}>Update</StyledButton>
                     <Message>{errorMessage}</Message>
                  </ButtonWrapper>
               </ButtonContainer>
            </Main>
         </Container>
      </>
   )
}

export default Shop
